import { ReactNode } from 'react';

import { ThemeColorInput } from 'shared/components/themes/ThemeColorInput';

import { ThemeControl } from '../ThemeControl';

type ColorInputPanelProps = {
  setColor: (newValue: string) => void;
  color?: string;
  globalPath?: string;
  label?: string;
  path?: string;
  ResetButton?: ReactNode;
  withGradient?: boolean;
};

export const ColorInputPanel = (props: ColorInputPanelProps) => {
  const { setColor, color, globalPath, label, path, ResetButton, withGradient = true } = props;
  return (
    <ThemeControl path={path} label={label} globalPath={globalPath}>
      <ThemeColorInput
        color={color ?? ''}
        onSelectColor={colorObject => setColor(colorObject.color)}
        withGradient={withGradient}
      />
      {ResetButton}
    </ThemeControl>
  );
};
